<template>
  <div class="login-modal">
    <div class="mask" @click="hiddenLogin"></div>
    <div class="login-box">
        <div v-if="step === 1">
            <div class="login-box-head">登录</div>
            <div class="login-box-content">
                <div class="login-box-input">
                    <input v-model="phone" placeholder="请输入您常用的手机号" />
                </div>
                <div class="login-box-input">
                    <input v-model="sms" placeholder="请输入验证码" />
                    <span @click="sendLoginSmsFun()">{{second === 0 ? "获取验证码" : `${second}秒`}}</span>
                </div>
                <div class="login-box-checkbox">
                    <!-- <el-checkbox v-model="checked" @change="handelChange"></el-checkbox> -->
                    <span>若您输入的手机号未注册，将为您直接注册，注册即视为同意<router-link :to="{name:'agreement', query:{type:'1'}}" target="_blank">版权家版权方用户注册协议</router-link>、<router-link :to="{name:'agreement', query:{type:'2'}}" target="_blank">版权家版权运营用户协议</router-link>、<router-link :to="{name:'agreement', query:{type:'3'}}" target="_blank">隐私协议</router-link></span>
                </div>
                <Button :loading="loading" class="button-area" @click="loginFun()">
                    登录
                </Button>
            </div>
        </div>
        <div v-else class="choose-role">
            <div class="close-style" style="text-align:center">
                <img style="margin-left:578px;" @click="logoutUmg" src="./images/iconclose.png" />
            </div>
            <div class="login-box-input">
                <input v-model="conpany" placeholder="请输入公司名称" />
            </div>
            <p class="choose-role-tips">我的角色</p>
            <div class="choose-role-list">
                <div class="role-item" @click="chooseRole('ROLE_COPYRIGHT')">
                    <div class="role-item-img">
                        <img :src="role === 'ROLE_COPYRIGHT' ? select12 : select1"/>
                    </div>
                    <span>版权方</span>
                </div>
                <div class="role-item" @click="chooseRole('ROLE_MEDIA')">
                    <div class="role-item-img">
                        <img :src="role === 'ROLE_MEDIA' ? select22 : select2"/>
                    </div>
                    <span>版权运营</span>
                </div>
            </div>
            <div class="button-area" @click="gotoIndex">
                进入首页
            </div>
        </div>
        
    </div>
    
  </div>
</template>
<script>
import {userLogin, getUserInfo, userAddRole, userSmsLogin, userValidateMobile, sendSmsLogin} from "../../api/login"
import {SET_USER_INFO} from "@/store/mutation-types.js"
import Cookies from "js-cookie";
import {sendRegistSms, sendLoginSms} from "../../api/sms"
import {setStore} from "../../libs/storage"
import {toLogout} from "../../api/login"
import {getStore, removeStore} from "../../libs/storage"
export default {
    data() {
        return {
            type: '',
            status: 'send',
            second: 0,
            step:1,
            checked: false,
            phone: '',
            loading:false,
            sms: '',
            role: '',
            conpany: '',
            select1:require("../../assets/icon-select-1-1.png"),
            select12:require("../../assets/icon-select-1-2.png"),
            select2:require("../../assets/icon-select-2-1.png"),
            select22:require("../../assets/icon-select-2-2.png"),
            // closeButton:require("./images/iconclose.png")
        }
    },
    props:{
        showRole: 0
    },
    watch:{
        showRole:{
            handler (newV, oldV) {
                console.log(newV)
                this.step = newV
                console.log(this.step)
            },
            deep:true
        }
    },
    mounted(){
        // console.log('this.showRole', this.showRole)
        // if(this.showRole == 0){
        //     this.step = 1
        // }
    },
    methods: {
        logoutUmg(){
            toLogout().then(res => {
                Cookies.remove('userInfo')
                removeStore('userInfo')
                removeStore('accessToken')
                window.location.href = "/"
            })
        },
        loginFun(){
            if(!this.phone){
                this.$message({message: '请输入手机号码', type: 'warning'});
                return false
            }else if(!this.sms){
                this.$message({message:'请输入手机短信验证码', type: 'warning'});
                return false
            }
            //  else if(!this.checked){
            //     this.$message({message:'登录需先阅读并同意《用户协议》', type: 'warning'});
            //     return false
            // }
            this.loading = true
            userSmsLogin({
            mobile: this.phone,
            smsCode: this.sms
            }).then(res => {
                if(res.code === 200){
                    this.loading = false
                    const result = res.result
                    setStore('accessToken', result.accessToken)
                    this.getUserInfoFun().then(res => {
                        if(!result.selected){
                            this.step = 0
                        } else {
                            this.$emit('hiddenFun')
                            window.location.reload()
                        }
                    })
                } else {
                     this.loading = false
                    this.$message.error(res.message);
                }
            }).catch(error => {
                console.error(error)
                 this.loading = false
                this.$message.error(error);
            })
        },
        chooseRole(v){
            console.log(v)
            this.role = v
        },
        timeCout(){
            let count = 60
            const timer = setInterval(()=>{
            count --
            if(count <= 1 ){
                this.second = 0
                clearInterval(timer)
            } else {
                 this.second = count
            }
           
            }, 1000)
        },
        sendLoginSmsFun(){
            if(!this.second){
                sendSmsLogin({
                    mobile: this.phone
                }).then(res => {
                    if(res.code === 200) {
                        this.timeCout()
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(error => {
                    console.error(error)
                    this.$message.error(error);
                })
            }
            
        },
        getUserInfoFun(){
            return new Promise((resolve,reject) => {
                getUserInfo().then(res => {
                    if(res.code === 200) {
                        const result = res.result
                        console.log(result)
                        this.$store.commit('SET_USER_INFO', {...result})
                        setStore("userInfo", JSON.stringify(result));
                        resolve()
                    } else {
                        this.$message.error(res.message);
                        reject()
                    }
                })
            })
        },
        gotoIndex(){
            if(!this.conpany){
                this.$message({message: '请输入公司名称', type: 'warning'});
                return false
            } else if(!this.role){
                this.$message({message: '请选择您的角色信息', type: 'warning'});
                return false
            }
            userAddRole({
                companyName: this.conpany,
                roleName: this.role
            }).then(res=> {
                if(res.code === 200) {
                    this.getUserInfoFun().then(res => {
                        window.location.href="/"
                    })
                    
                } else {
                    this.$message.error(res.message);
                }
            }).catch(error => {
                console.error(error)
                this.$message.error(error);
            })
           
        },
        hiddenLogin(){
           this.$emit('hiddenFun')
        },
        handelChange(v){
            this.checked = v
        }
    }
}
</script>
<style lang="stylus" scoped>
    .close-style{
        position fixed
        right 0
        left 0
        margin 0 auto
        top 172px
        cursor pointer
    }
    .login-modal{
        position fixed
        left 0
        top 0
        z-index 99
        width 100%
        height 100%
        .mask{
            position fixed
            left 0
            top 0
            z-index 99
            background rgba(0,0,0,0.35)
            width 100%
            height 100%
            z-index 99
        }
        .login-box{
            width: 550px;
            height 400px;
            background: #FFFFFF;
            border-radius: 10px;
            position: fixed;
            z-index 990
            margin 0 auto
            left 0
            right 0
            top 200px
            overflow hidden
            .login-box-head{
                height 60px
                line-height 60px
                text-align center
                font-family: NotoSansHans-Medium;
                font-size: 18px;
                color: #666666;
                border-bottom 1px solid #EEEEEE;
                margin-bottom 30px
            }
            .login-box-content{
                width 300px
                height 100%
                margin 0 auto
                
                .login-box-checkbox{
                    color: #999999 !important;
                    margin-bottom 33px
                    a{
                        color blue
                        font-size: 14px;
                    }
                }
            }
        }
        .login-box-input{
            height 35px
            margin-bottom 20px
            position relative
            label{
                span{
                    background: #FDDA00 !important;
                    border-color: #FDDA00 !important;
                }
            }
            input{
                display inline-block
                width 100%
                height 100%
                border: 1px solid #D8D8D8;
                padding 10px
                box-sizing border-box
                font-size: 14px;
                color: #666666;
            }
            span{
                display inline-block
                position absolute
                right 5px
                top 5px
                height 25px
                line-height 25px
                background: #E8E8E8;
                border-radius 5px
                padding 0 10px
                font-size 14px
                color: #666666;
                cursor pointer
            }
            a{
                color blue
                font-size: 14px;
            }
        }

        .button-area{
            height 35px
            line-height 35px
            text-align center
            width 100%
            background: #FDDA00;
            font-size: 14px;
            color: #333333;
            cursor pointer
        }
        .choose-role{
            width 300px
            margin 40px auto 0
            .choose-role-tips{
                margin-bottom 20px
                color #666666
            }
            .choose-role-list{
                display flex
                align-items center
                justify-content :center
                margin-bottom 39px
                .role-item{
                    width 67px
                    height 91px
                    display flex
                    flex-wrap wrap
                    cursor pointer
                    justify-content center
                    .role-item-img{
                        width 67px
                        height 67px
                        img{
                            width 100%
                            height 100%
                        }
                    }

                }
                .role-item:first-of-type{
                    margin-right 76px
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/login/index.vue